// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"fd049559","421":"04c94ece","630":"ed54b502","831":"0f5cdb58"}[chunkId] + ".css";
};